"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _preact = require("preact");
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
var AuthView = require("./AuthView.js");
var Header = require("./Header.js");
var Browser = require("../Browser.js");
var LoaderView = require("../Loader.js");
var CloseWrapper = require("../CloseWrapper.js");
var View = require("../View.js");
var packageJson = {
  "version": "2.1.3"
};
function getOrigin() {
  // eslint-disable-next-line no-restricted-globals
  return location.origin;
}
function getRegex(value) {
  if (typeof value === 'string') {
    return new RegExp("^".concat(value, "$"));
  }
  if (value instanceof RegExp) {
    return value;
  }
  return undefined;
}
function isOriginAllowed(origin, allowedOrigin) {
  var patterns = Array.isArray(allowedOrigin) ? allowedOrigin.map(getRegex) : [getRegex(allowedOrigin)];
  return patterns.some(function (pattern) {
    return (pattern == null ? void 0 : pattern.test(origin)) || (pattern == null ? void 0 : pattern.test("".concat(origin, "/")));
  }); // allowing for trailing '/'
}
/**
 * Class to easily generate generic views for Provider plugins
 */

var _updateFilesAndFolders = /*#__PURE__*/_classPrivateFieldLooseKey("updateFilesAndFolders");
var ProviderView = /*#__PURE__*/function (_View) {
  _inherits(ProviderView, _View);
  var _super = _createSuper(ProviderView);
  /**
   * @param {object} plugin instance of the plugin
   * @param {object} opts
   */
  function ProviderView(plugin, opts) {
    var _this2;
    _classCallCheck(this, ProviderView);
    _this2 = _super.call(this, plugin, opts); // set default options

    Object.defineProperty(_assertThisInitialized(_this2), _updateFilesAndFolders, {
      value: _updateFilesAndFolders2
    });
    var defaultOptions = {
      viewType: 'list',
      showTitles: true,
      showFilter: true,
      showBreadcrumbs: true
    }; // merge default options with the ones set by user

    _this2.opts = _objectSpread(_objectSpread({}, defaultOptions), opts); // Logic

    _this2.filterQuery = _this2.filterQuery.bind(_assertThisInitialized(_this2));
    _this2.getFolder = _this2.getFolder.bind(_assertThisInitialized(_this2));
    _this2.getNextFolder = _this2.getNextFolder.bind(_assertThisInitialized(_this2));
    _this2.logout = _this2.logout.bind(_assertThisInitialized(_this2));
    _this2.handleAuth = _this2.handleAuth.bind(_assertThisInitialized(_this2));
    _this2.handleScroll = _this2.handleScroll.bind(_assertThisInitialized(_this2));
    _this2.listAllFiles = _this2.listAllFiles.bind(_assertThisInitialized(_this2));
    _this2.donePicking = _this2.donePicking.bind(_assertThisInitialized(_this2)); // Visual

    _this2.render = _this2.render.bind(_assertThisInitialized(_this2)); // Set default state for the plugin

    _this2.plugin.setPluginState({
      authenticated: false,
      files: [],
      folders: [],
      directories: [],
      filterInput: '',
      isSearchVisible: false,
      currentSelection: []
    });
    return _this2;
  } // eslint-disable-next-line class-methods-use-this
  _createClass(ProviderView, [{
    key: "tearDown",
    value: function tearDown() {// Nothing.
    }

    /**
     * Based on folder ID, fetch a new folder and update it to state
     *
     * @param  {string} id Folder id
     * @returns {Promise}   Folders/files in folder
     */
  }, {
    key: "getFolder",
    value: function getFolder(id, name) {
      var _this3 = this;
      return this.sharedHandler.loaderWrapper(this.provider.list(id), function (res) {
        var folders = [];
        var files = [];
        var updatedDirectories;
        var state = _this3.plugin.getPluginState();
        var index = state.directories.findIndex(function (dir) {
          return id === dir.id;
        });
        if (index !== -1) {
          updatedDirectories = state.directories.slice(0, index + 1);
        } else {
          updatedDirectories = state.directories.concat([{
            id: id,
            title: name
          }]);
        }
        _this3.username = res.username || _this3.username;
        _classPrivateFieldLooseBase(_this3, _updateFilesAndFolders)[_updateFilesAndFolders](res, files, folders);
        _this3.plugin.setPluginState({
          directories: updatedDirectories
        });
      }, this.handleError);
    }
    /**
     * Fetches new folder
     *
     * @param  {object} folder
     */
  }, {
    key: "getNextFolder",
    value: function getNextFolder(folder) {
      this.getFolder(folder.requestPath, folder.name);
      this.lastCheckbox = undefined;
    }
    /**
     * Removes session token on client side.
     */
  }, {
    key: "logout",
    value: function logout() {
      var _this4 = this;
      this.provider.logout().then(function (res) {
        if (res.ok) {
          if (!res.revoked) {
            var message = _this4.plugin.uppy.i18n('companionUnauthorizeHint', {
              provider: _this4.plugin.title,
              url: res.manual_revoke_url
            });
            _this4.plugin.uppy.info(message, 'info', 7000);
          }
          var newState = {
            authenticated: false,
            files: [],
            folders: [],
            directories: []
          };
          _this4.plugin.setPluginState(newState);
        }
      }).catch(this.handleError);
    }
  }, {
    key: "filterQuery",
    value: function filterQuery(e) {
      var state = this.plugin.getPluginState();
      this.plugin.setPluginState(_objectSpread(_objectSpread({}, state), {}, {
        filterInput: e ? e.target.value : ''
      }));
    }
    /**
     * Adds all files found inside of specified folder.
     *
     * Uses separated state while folder contents are being fetched and
     * mantains list of selected folders, which are separated from files.
     */
  }, {
    key: "addFolder",
    value: function addFolder(folder) {
      var _this5 = this;
      var folderId = this.providerFileToId(folder);
      var folders = _objectSpread({}, this.plugin.getPluginState().selectedFolders);
      if (folderId in folders && folders[folderId].loading) {
        return;
      }
      folders[folderId] = {
        loading: true,
        files: []
      };
      this.plugin.setPluginState({
        selectedFolders: _objectSpread({}, folders)
      }); // eslint-disable-next-line consistent-return

      return this.listAllFiles(folder.requestPath).then(function (files) {
        var count = 0; // If the same folder is added again, we don't want to send
        // X amount of duplicate file notifications, we want to say
        // the folder was already added. This checks if all files are duplicate,
        // if that's the case, we don't add the files.

        files.forEach(function (file) {
          var id = _this5.providerFileToId(file);
          if (!_this5.plugin.uppy.checkIfFileAlreadyExists(id)) {
            count++;
          }
        });
        if (count > 0) {
          files.forEach(function (file) {
            return _this5.addFile(file);
          });
        }
        var ids = files.map(_this5.providerFileToId);
        folders[folderId] = {
          loading: false,
          files: ids
        };
        _this5.plugin.setPluginState({
          selectedFolders: folders
        });
        var message;
        if (count === 0) {
          message = _this5.plugin.uppy.i18n('folderAlreadyAdded', {
            folder: folder.name
          });
        } else if (files.length) {
          message = _this5.plugin.uppy.i18n('folderAdded', {
            smart_count: count,
            folder: folder.name
          });
        } else {
          message = _this5.plugin.uppy.i18n('emptyFolderAdded');
        }
        _this5.plugin.uppy.info(message);
      }).catch(function (e) {
        var selectedFolders = _objectSpread({}, _this5.plugin.getPluginState().selectedFolders);
        delete selectedFolders[folderId];
        _this5.plugin.setPluginState({
          selectedFolders: selectedFolders
        });
        _this5.handleError(e);
      });
    }
  }, {
    key: "handleAuth",
    value: function () {
      var _handleAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this6 = this;
        var authState, clientVersion, link, authWindow, handleToken;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.provider.ensurePreAuth();
            case 2:
              authState = btoa(JSON.stringify({
                origin: getOrigin()
              }));
              clientVersion = "@uppy/provider-views=".concat(ProviderView.VERSION);
              link = this.provider.authUrl({
                state: authState,
                uppyVersions: clientVersion
              });
              authWindow = window.open(link, '_blank');
              handleToken = function handleToken(e) {
                if (e.source !== authWindow) {
                  _this6.plugin.uppy.log('rejecting event from unknown source');
                  return;
                }
                if (!isOriginAllowed(e.origin, _this6.plugin.opts.companionAllowedHosts) || e.source !== authWindow) {
                  _this6.plugin.uppy.log("rejecting event from ".concat(e.origin, " vs allowed pattern ").concat(_this6.plugin.opts.companionAllowedHosts));
                } // Check if it's a string before doing the JSON.parse to maintain support
                // for older Companion versions that used object references

                var data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
                if (data.error) {
                  _this6.plugin.uppy.log('auth aborted', 'warning');
                  var uppy = _this6.plugin.uppy;
                  var message = uppy.i18n('authAborted');
                  uppy.info({
                    message: message
                  }, 'warning', 5000);
                  return;
                }
                if (!data.token) {
                  _this6.plugin.uppy.log('did not receive token from auth window', 'error');
                  return;
                }
                authWindow.close();
                window.removeEventListener('message', handleToken);
                _this6.provider.setAuthToken(data.token);
                _this6.preFirstRender();
              };
              window.addEventListener('message', handleToken);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleAuth() {
        return _handleAuth.apply(this, arguments);
      }
      return handleAuth;
    }()
  }, {
    key: "handleScroll",
    value: function () {
      var _handleScroll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var path, response, _this$plugin$getPlugi, files, folders;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              path = this.nextPagePath || null;
              if (!(this.shouldHandleScroll(event) && path)) {
                _context2.next = 17;
                break;
              }
              this.isHandlingScroll = true;
              _context2.prev = 3;
              _context2.next = 6;
              return this.provider.list(path);
            case 6:
              response = _context2.sent;
              _this$plugin$getPlugi = this.plugin.getPluginState(), files = _this$plugin$getPlugi.files, folders = _this$plugin$getPlugi.folders;
              _classPrivateFieldLooseBase(this, _updateFilesAndFolders)[_updateFilesAndFolders](response, files, folders);
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](3);
              this.handleError(_context2.t0);
            case 14:
              _context2.prev = 14;
              this.isHandlingScroll = false;
              return _context2.finish(14);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 11, 14, 17]]);
      }));
      function handleScroll(_x) {
        return _handleScroll.apply(this, arguments);
      }
      return handleScroll;
    }()
  }, {
    key: "listAllFiles",
    value: function () {
      var _listAllFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(path, files) {
        var _this7 = this;
        var res, moreFiles;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (files === void 0) {
                files = null;
              }
              files = files || []; // eslint-disable-line no-param-reassign
              _context3.next = 4;
              return this.provider.list(path);
            case 4:
              res = _context3.sent;
              res.items.forEach(function (item) {
                if (!item.isFolder) {
                  files.push(item);
                } else {
                  _this7.addFolder(item);
                }
              });
              moreFiles = res.nextPagePath;
              if (!moreFiles) {
                _context3.next = 9;
                break;
              }
              return _context3.abrupt("return", this.listAllFiles(moreFiles, files));
            case 9:
              return _context3.abrupt("return", files);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function listAllFiles(_x2, _x3) {
        return _listAllFiles.apply(this, arguments);
      }
      return listAllFiles;
    }()
  }, {
    key: "donePicking",
    value: function donePicking() {
      var _this8 = this;
      var _this$plugin$getPlugi2 = this.plugin.getPluginState(),
        currentSelection = _this$plugin$getPlugi2.currentSelection;
      var promises = currentSelection.map(function (file) {
        if (file.isFolder) {
          return _this8.addFolder(file);
        }
        return _this8.addFile(file);
      });
      this.sharedHandler.loaderWrapper(Promise.all(promises), function () {
        _this8.clearSelection();
      }, function () {});
    }
  }, {
    key: "render",
    value: function render(state, viewOptions) {
      var _this = this;
      if (viewOptions === void 0) {
        viewOptions = {};
      }
      var _this$plugin$getPlugi3 = this.plugin.getPluginState(),
        authenticated = _this$plugin$getPlugi3.authenticated,
        didFirstRender = _this$plugin$getPlugi3.didFirstRender;
      if (!didFirstRender) {
        this.preFirstRender();
      }
      var targetViewOptions = _objectSpread(_objectSpread({}, this.opts), viewOptions);
      var _this$plugin$getPlugi4 = this.plugin.getPluginState(),
        files = _this$plugin$getPlugi4.files,
        folders = _this$plugin$getPlugi4.folders,
        filterInput = _this$plugin$getPlugi4.filterInput,
        loading = _this$plugin$getPlugi4.loading,
        currentSelection = _this$plugin$getPlugi4.currentSelection;
      var _this$sharedHandler = this.sharedHandler,
        isChecked = _this$sharedHandler.isChecked,
        toggleCheckbox = _this$sharedHandler.toggleCheckbox,
        recordShiftKeyPress = _this$sharedHandler.recordShiftKeyPress,
        filterItems = _this$sharedHandler.filterItems;
      var hasInput = filterInput !== '';
      var headerProps = {
        showBreadcrumbs: targetViewOptions.showBreadcrumbs,
        getFolder: this.getFolder,
        directories: this.plugin.getPluginState().directories,
        pluginIcon: this.plugin.icon,
        title: this.plugin.title,
        logout: this.logout,
        username: this.username,
        i18n: this.plugin.uppy.i18n
      };
      var browserProps = {
        isChecked: isChecked,
        toggleCheckbox: toggleCheckbox,
        recordShiftKeyPress: recordShiftKeyPress,
        currentSelection: currentSelection,
        files: hasInput ? filterItems(files) : files,
        folders: hasInput ? filterItems(folders) : folders,
        username: this.username,
        getNextFolder: this.getNextFolder,
        getFolder: this.getFolder,
        filterItems: this.sharedHandler.filterItems,
        filterQuery: this.filterQuery,
        logout: this.logout,
        handleScroll: this.handleScroll,
        listAllFiles: this.listAllFiles,
        done: this.donePicking,
        cancel: this.cancelPicking,
        headerComponent: Header(headerProps),
        title: this.plugin.title,
        viewType: targetViewOptions.viewType,
        showTitles: targetViewOptions.showTitles,
        showFilter: targetViewOptions.showFilter,
        showBreadcrumbs: targetViewOptions.showBreadcrumbs,
        pluginIcon: this.plugin.icon,
        i18n: this.plugin.uppy.i18n,
        uppyFiles: this.plugin.uppy.getFiles(),
        validateRestrictions: function validateRestrictions() {
          var _this$plugin$uppy;
          return (_this$plugin$uppy = _this.plugin.uppy).validateRestrictions.apply(_this$plugin$uppy, arguments);
        }
      };
      if (loading) {
        return (0, _preact.h)(CloseWrapper, {
          onUnmount: this.clearSelection
        }, (0, _preact.h)(LoaderView, {
          i18n: this.plugin.uppy.i18n
        }));
      }
      if (!authenticated) {
        return (0, _preact.h)(CloseWrapper, {
          onUnmount: this.clearSelection
        }, (0, _preact.h)(AuthView, {
          pluginName: this.plugin.title,
          pluginIcon: this.plugin.icon,
          handleAuth: this.handleAuth,
          i18n: this.plugin.uppy.i18n,
          i18nArray: this.plugin.uppy.i18nArray
        }));
      }
      return (0, _preact.h)(CloseWrapper, {
        onUnmount: this.clearSelection
      }, (0, _preact.h)(Browser, browserProps));
    }
  }]);
  return ProviderView;
}(View);
function _updateFilesAndFolders2(res, files, folders) {
  this.nextPagePath = res.nextPagePath;
  res.items.forEach(function (item) {
    if (item.isFolder) {
      folders.push(item);
    } else {
      files.push(item);
    }
  });
  this.plugin.setPluginState({
    folders: folders,
    files: files
  });
}
ProviderView.VERSION = packageJson.version;
module.exports = ProviderView;